import React, { ReactElement } from 'react';
import { isDarkMode } from 'utils/helpers';

interface RepliedIconProps {
  size?: number;
  color?: string;
}

const RepliedIcon = ({ size = 16, color = isDarkMode() ? '#AFB0B1' : '#595959' }: RepliedIconProps): ReactElement => {
  return (
    <span style={{ verticalAlign: 'middle' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <mask
          id="mask0_4108_29878"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={`${size}px`}
          height={`${size}px`}
        >
          <rect width={`${size}px`} height={`${size}px`} fill={'#D9D9D9'} />
        </mask>
        <g mask="url(#mask0_4108_29878)">
          <path
            d="M4.69997 8.09909L6.3333 9.73242C6.45552 9.85464 6.51663 9.99631 6.51663 10.1574C6.51663 10.3185 6.45552 10.4629 6.3333 10.5904C6.21108 10.7073 6.06941 10.7658 5.9083 10.7658C5.74719 10.7658 5.60552 10.7046 5.4833 10.5824L2.81663 7.91576C2.69441 7.79753 2.6333 7.65964 2.6333 7.50209C2.6333 7.34453 2.69441 7.20464 2.81663 7.08242L5.4833 4.41576C5.60552 4.29353 5.74813 4.23242 5.91113 4.23242C6.07402 4.23242 6.21475 4.29353 6.3333 4.41576C6.45552 4.53431 6.51663 4.67503 6.51663 4.83792C6.51663 5.00092 6.45552 5.14353 6.3333 5.26576L4.69997 6.89909H10.4C11.2853 6.89909 12.04 7.21109 12.664 7.83509C13.288 8.45909 13.6 9.21376 13.6 10.0991V11.8991C13.6 12.0691 13.5428 12.2116 13.4285 12.3266C13.3141 12.4416 13.1725 12.4991 13.0035 12.4991C12.8345 12.4991 12.6916 12.4416 12.575 12.3266C12.4583 12.2116 12.4 12.0691 12.4 11.8991V10.0991C12.4 9.54353 12.2055 9.07131 11.8166 8.68242C11.4277 8.29353 10.9555 8.09909 10.4 8.09909H4.69997Z"
            fill={color}
          />
        </g>
      </svg>
    </span>
  );
};

export default RepliedIcon;
